import { deleteTable } from "@/api/BranchSiteMap";
import { releaseTable } from "@/api/Cart";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
    components: {
        VuePerfectScrollbar,
    },
    data() {
        return {
            editMode: false,
            selectedTableId: null,
            selectedTableNumber: null,
            showOperationDetails: false,
            isMobile: null,
        };
    },
    methods: {
        toggleActiveTables() {
            this.$store.commit("selfservice/SET_IS_ACTIVE_TABLES_FILTER", !this.isActiveTablesFilter);
        },
        addOrder() {
            this.showOperationDetails = false;
            this.$emit("startOrder", this.selectedTableId);
        },
        startPayment() {
            this.showOperationDetails = false;
            this.$emit("startPayment", this.selectedTableId);
        },
        mergeTable() {
            //   this.isTableMerge = !this.isTableMerge;
            this.$emit("mergeTable", !this.isTableMerge);
            this.showOperationDetails = false;
            // Notify the user about the merge status
            this.$vs.notify({
                color: this.isTableMerge ? "success" : "warning",
                title: this.isTableMerge
                    ? "Birleştirme Başladı"
                    : "Birleştirme İptal Edildi",
                text: this.isTableMerge
                    ? "Masa birleştirme başlatıldı."
                    : "Masa birleştirme iptal edildi.",
            });
        },
        transferTable() {
            //this.isTableMove = !this.isTableMove;
            this.$emit("transferTable", !this.isTableMove);
            this.showOperationDetails = false;
            // Notify the user about the transfer status
            this.$vs.notify({
                color: this.isTableMove ? "success" : "warning",
                title: this.isTableMove ? "Transfer Başladı" : "Transfer İptal Edildi",
                text: this.isTableMove
                    ? "Masa transferi başlatıldı."
                    : "Masa transferi iptal edildi.",
            });
        },
        editOrder() {
            this.$emit("editOrder", this.selectedTableId);
        },
        splitTable() {
            this.showOperationDetails = false;
            this.$vs.dialog({
                type: "confirm",
                color: "warning",
                title: "Masa Ayırma",
                text: "Bu masayı ayırmak istediğinizden emin misiniz?",
                acceptText: "Evet, Ayır",
                cancelText: "İptal",
                accept: () => {
                    this.$emit("splitTable", this.selectedTableId);
                },
                cancel: () => { },
            });
        },
        toggleEditMode() {
            if (!this.editMode) {
                this.$emit("editModeOn");
            } else {
                this.$emit("editModeOff");
            }
            this.editMode = !this.editMode;
        },
        reserveTable() {
            this.showOperationDetails = false;
            this.$emit("reserveTable", this.selectedTableId);
        },
        unreserveTable() {
            this.showOperationDetails = false;
            this.$emit("unreserveTable", this.selectedTableId);
        },
        showOrderTimes() { },
        lossModeActive() {
            this.showOperationDetails = false;
            this.$emit("un-select-table");
            this.$emit("lossModeActive");
        },
        goToSelfService2() {
            // Clear all carts
            this.$store.dispatch("selfservice/clearAllCarts");
            // Reload page and navigate to SelfService2
            window.location.href = '/pages/selfservice2?notSwitch=true';
        },
        exit() {
            this.$emit("exit");
        },
        deleteTable() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Masayı Sil",
                text: "Bu masayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
                acceptText: "Evet, Sil",
                cancelText: "İptal",
                buttonColor: "danger",
                accept: () => {
                    deleteTable(this.selectedTableId).then(() => {
                        this.$emit("refreshBranchMap");
                        this.$vs.notify({
                            color: "success",
                            title: "Başarılı",
                            text: "Masa başarıyla silindi.",
                        });
                    });
                },
                cancel: () => { },
            });
        },
        showAdisyon() {
            this.showOperationDetails = false;
            this.$emit("showAdisyon", this.selectedTableId);
        },
        toggleOperationsDetail() {
            this.showOperationDetails = !this.showOperationDetails;
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768; // Adjust this value as needed
        },
        releaseLock() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Kilidi Kaldır",
                text: `${this.lockedByUserName} tarafından konulan kilidi kaldırmak istediğinizden emin misiniz?`,
                acceptText: "Evet, Kaldır",
                cancelText: "İptal",
                accept: async () => {
                    await releaseTable(this.selectedTableId);
                    this.$emit("refreshBranchMap");
                    this.$vs.notify({
                        color: "success",
                        title: "Başarılı",
                        text: "Masa kilidi başarıyla kaldırıldı.",
                    });
                },
            });
        },
    },
    async created() {
        this.checkMobile();
        window.addEventListener("resize", this.checkMobile);
    },
    computed: {
        currentTab() {
            return this.$store.getters["selfservice/getCurrentTab"];
        },
        isActiveTablesFilter() {
            return this.$store.getters["selfservice/getIsActiveTablesFilter"];
        },
        isTableMove() {
            return this.$store.getters["selfservice/getIsTableMove"];
        },
        isTableMerge() {
            return this.$store.getters["selfservice/getIsTableMerge"];
        },
        areas() {
            return this.$store.getters["selfservice/getAreas"];
        },
        isShowGetPayment() {
            if (!this.selectedTableId) {
                return false;
            }
            var carts = this.$store.getters["selfservice/getCarts"];
            const existingCart = carts.find(
                (cart) => cart != null && cart.tableId === this.selectedTableId
            );
            console.log("existingCart", existingCart);
            console.log("selectedTableId", this.selectedTableId); 
            return (
                existingCart &&
                existingCart.paymentGroups &&
                !!existingCart.paymentGroups.length
            );
        },
        isMergeBase() {
            if (!this.selectedTableId) {
                return false;
            }
            const allButtons = this.areas.flatMap((area) => area.buttons);
            const button = allButtons.find(
                (button) => button.id === this.selectedTableId
            );
            return button && button.mergedIds && !!button.mergedIds.length;
        },
        isReserveTable() {
            const allButtons = this.areas.flatMap((area) => area.buttons);
            const button = allButtons.find(
                (button) => button.id === this.selectedTableId
            );
            if (!this.selectedTableId) {
                return false;
            }
            var carts = this.$store.getters["selfservice/getCarts"];
            const existingCart = carts.find(
                (cart) => cart != null && cart.tableId === this.selectedTableId
            );
            if (!existingCart) {
                return button.value.isFullTable;
            }
            return existingCart && existingCart.isFullTable;
        },
        isLocked() {
            if (!this.selectedTableId) return false;
            const carts = this.$store.getters["selfservice/getCarts"];
            const existingCart = carts.find(c => c != null && c.tableId === this.selectedTableId);
            return existingCart && existingCart.lockedByUserId != null;
        },
        lockedByUserName() {
            if (!this.selectedTableId) return "";
            const carts = this.$store.getters["selfservice/getCarts"];
            const existingCart = carts.find(c => c != null && c.tableId === this.selectedTableId);
            return existingCart ? existingCart.lockedByUserName : "";
        },
        isLockedByOther() {
            if (!this.selectedTableId) return false;
            const carts = this.$store.getters["selfservice/getCarts"];
            const existingCart = carts.find(c => c != null && c.tableId === this.selectedTableId);
            if (!existingCart || existingCart.lockedByUserId == null) return false;

            const currentUser = this.$store.getters["getActiveUser"];
            // Eğer kilitli kullanıcı ID'si benim ID'mden farklıysa başkası kilitlemiştir
            return existingCart.lockedByUserId !== currentUser.id;
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkMobile);
    },
};